<template>
    <div class="pop-video-box" v-if="visible">
        <div class="mask"></div>
        <div class="video-content">
            <video v-if="!config.isIframe" :src="config.videoUrl" :poster="config.videoPoster" autobuffer controlslist="nodownload" :disablePictureInPicture="true" controls webkit-playsinline="true" playsinline="true" :autoplay="config.autoplay" width="100%"></video>
            <iframe v-else :src="config.iframeUrl" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe>
            <div class="pop-video-close-btn" @click="closeBox"></div>
        </div>
    </div>
</template>

<script>

  export default {
    props: {
        config: {
            type: Object
        },
        visible: {
            type: Boolean
        },
        // isIframe: {
        //     type: Boolean
        // },
        // iframeUrl: {
        //     type: String
        // }
    },
    created(){
        // console.log(this.isIframe);
    },
    methods:{
        closeBox(){
            this.$emit('closeVideo', !this.visible)
        }
    }
    // data() {
    //     return {

    //     }
    // },
  }
</script>

<style lang="scss" scoped>
    .pop-video-box{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        overflow: hidden;
        z-index: 3000;
        // &.openBox{
        // }
    }
    .mask{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba($color: #000000, $alpha: 0.9);
    }
    .video-content{
        position: relative;
        width: 1200px;
        height: 675px;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and (max-width:768px){
            width: 100%;
            height: 300Px;
        }
    }
    video,iframe{
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @media screen and (max-width:768px){
            height: auto;
        }
    }
    .pop-video-close-btn{
        position: absolute;
        top: -50px;
        right: 0;
        width: 30px;
        height: 30px;
        // background-color: red;
        cursor: pointer;
        background-image: url(../assets/svg/close-white.svg);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        @media screen and (max-width:768px){
            width: 20Px;
            height: 20Px;
            top: -30Px;
            right: 20Px;
        }
    }
</style>